import PopupContent from './PopupContent';
import PopupHeader from './PopupHeader';
import PopupSeparator from './PopupSeparator';

export default class Popup {
  static Header = PopupHeader;

  static Content = PopupContent;

  static Separator = PopupSeparator;
}
